module.exports = __webpack_public_path__ + "static/img/tit3.2276dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tit3.png
// module id = w9Dw
// module chunks = 1